import { getPerformanceEntryForResourceSync } from 'mini-performance/lib/utils/resourcePerformanceObserver';
import { getTimeFromFetchStart } from 'mini-performance/lib/utils/getTimeFromFetchStart';

const timingDataCache = new Map();

export const getTimingData = (resource: string, includeSizeData = false): string | void => {
    if (!timingDataCache.has(resource)) {
        const performanceEntry = getPerformanceEntryForResourceSync(resource);
        if (performanceEntry) {
            let timingData = `${Math.round(
                getTimeFromFetchStart(performanceEntry.requestStart)
            )}_${Math.round(getTimeFromFetchStart(performanceEntry.responseStart))}_${Math.round(
                getTimeFromFetchStart(performanceEntry.responseEnd)
            )}`;

            if (includeSizeData) {
                timingData = `${timingData}_${performanceEntry.duration}_${performanceEntry.transferSize}_${performanceEntry.decodedBodySize}`;
            }

            timingDataCache.set(resource, timingData);
        }
    }

    return timingDataCache.get(resource);
};
